/** sessionStorage key: after Auth0 logout, auto-start login (Allowed Logout URLs often permit origin only). */
export const POST_LOGOUT_LOGIN_STORAGE_KEY = 'club4x4_post_logout_login'

/** Set before logout when user switches from signup/link flow to an existing account login. */
export function setPostLogoutLoginIntent(): void {
  sessionStorage.setItem(POST_LOGOUT_LOGIN_STORAGE_KEY, '1')
}

/** Returns true once when the post-logout login intent is present; clears the flag. */
export function consumePostLogoutLoginIntent(): boolean {
  if (sessionStorage.getItem(POST_LOGOUT_LOGIN_STORAGE_KEY) !== '1') {
    return false
  }
  sessionStorage.removeItem(POST_LOGOUT_LOGIN_STORAGE_KEY)
  return true
}
